import { CommonFrontOfficeCrumbs } from './breadcrumb';

export const StatementsCrumbs = [
  ...CommonFrontOfficeCrumbs,
  {
    name: 'Dichiarazioni',
    path: '/sportello/dichiarazioni',
  },
];
